import React from "react";
import "./styles/Dot.style.css";

function Dot() {
  return (
    <div className='dot'></div>
  );
}

export default Dot;
